import { render } from "./taxInnvoiceAr.vue?vue&type=template&id=2ad576e7&scoped=true"
import script from "./taxInnvoiceAr.vue?vue&type=script&lang=js"
export * from "./taxInnvoiceAr.vue?vue&type=script&lang=js"

import "./taxInnvoiceAr.vue?vue&type=style&index=0&id=2ad576e7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad576e7"]])

export default __exports__